import { Box } from '@primer/react';
import { useEffect } from 'react';
import { Pie } from 'react-chartjs-2';
import { useDispatch, useSelector } from 'react-redux';
import { useCommonSelectedHook } from '../../hooks/useCommonSelectedHook';
import { actions } from '../../state/actions/actionsWrapper';
import { RootState } from '../../state/reducers';
import Block from './Block';
const mainAction = actions.thongKe.cskh;
const ThongKeCSKH = () => {
    const { status, data } = useSelector((x: RootState) => x.thongKe.cskh)
    const { nam_hoc, dm_coso_id } = useCommonSelectedHook();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(mainAction.LOAD_START({
            nam_hoc,
            dm_coso_id
        }))

    }, [nam_hoc, dm_coso_id])


    // Chuẩn bị dữ liệu cho Bar Chart
    const dataSource = {
        labels: data.map(item => item.name), // Nhãn các môn học
        datasets: [
            {
                label: '',
                data: data.map(item => item.count), // Điểm tương ứng
                backgroundColor: data.map((t, idx) => {
                    return t.color;
                    // return colors[idx % colors.length].hex;
                }),
                borderColor: data.map((t, idx) => {
                    return t.color;
                    // return colors[idx % colors.length].hex;
                }),
                borderWidth: 1,
                barThickness: 20, // Độ dày của thanh Bar (pixel)
                maxBarThickness: 30, // Độ dày tối đa của mỗi Bar
                borderRadius: 4, // Bo tròn góc tha
            },
        ],
    };
    const options: any = {
        responsive: true,
        plugins: {
            legend: {
                position: 'right',
                display: false,
            },
            title: {
                display: false,
                text: 'Chăm sóc khách hàng',
            },
            datalabels: {
                color: '#fff',
                font: {
                    weight: 'bold',
                    size: 13,
                },
            },
        },
    };
    return (
        <>
            <Box sx={{ fontSize: 24, fontWeight: 600 }}>Chăm sóc khách hàng</Box>
            <Box sx={{ fontSize: "1rem", color: "fg.muted" }}>Số lượng yêu cầu hỗ trợ</Box>
            <Box sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mt: 3,
            }}>
                <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
                    <Box sx={{
                        height: "180px"
                    }}>
                        <Pie data={dataSource} options={options} />
                    </Box>
                </Box>
                <Box sx={{ flex: 1 }}>
                    <Box sx={{
                        display: "flex",
                        flexDirection: "column"
                    }}>
                        {data.map((t, idx) => {
                            return <Box key={idx} sx={{
                                display: "flex",
                                mb: 2
                            }}>
                                <Box sx={{
                                    backgroundColor: t.color,
                                    width: "24px",
                                    height: "24px",
                                    borderRadius: "4px",
                                }}>&nbsp;</Box>
                                <Box sx={{
                                    ml: 2,
                                    fontWeight: "600"
                                }}>{t.name} : {t.count} yêu cầu</Box>
                            </Box>
                        })}
                    </Box>
                </Box>
            </Box>
        </>
    );
};

export default ThongKeCSKH;